// Lib
import React from 'react';
import Box from '@mui/material/Box';
import { format } from 'date-fns';

// Components
import InfoCardField from './InfoCardField';
import InfoCardShippingMethod from './InfoCardShippingMethod';

// Hooks
import useUI from '../../../../hooks/useUI';
import useUser from '../../../../hooks/useUser';

// Styles
import { useStyles } from './InfoCardStyles';

const formatOrderDate = (date) =>
  date ? format(new Date(date), 'MM/dd/yyyy') : null;

const formatShipDate = (date) =>
  date ? format(new Date(date), 'MM/dd/yyyy') : '-';

const InfoCard = ({ orderDetails }) => {
  const { isMobileMode } = useUI();
  const { isKiteUser, userWithoutAllLimits } = useUser();
  const { classes } = useStyles({ isKiteUser });

  return (
    <Box className={isMobileMode ? {} : classes.orderInfo}>
      <InfoCardField
        label="Order ID"
        value={orderDetails.order_sn}
        isMobileMode={isMobileMode}
        variant="h3"
      />
      <InfoCardField
        label="Order Date"
        value={formatOrderDate(orderDetails.created)}
        isMobileMode={isMobileMode}
        labelClassName={classes.orderInfoHeader}
        valueClassName={classes.orderInfoText}
      />
      <InfoCardField
        label="Ship Date"
        value={formatShipDate(orderDetails.ship_date)}
        isMobileMode={isMobileMode}
        labelClassName={classes.orderInfoHeader}
        valueClassName={classes.orderInfoText}
      />
      <InfoCardShippingMethod
        orderDetails={orderDetails}
        isMobileMode={isMobileMode}
        userWithoutAllLimits={userWithoutAllLimits}
        classes={classes}
      />
    </Box>
  );
};

export default InfoCard;
